import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { CheckCircleOutline, CloudDownload } from "@mui/icons-material";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
interface DownloadUpgradeDialogProps {
  open: boolean;
  onClose: () => void;
}

const DownloadUpgradeDialog: React.FC<DownloadUpgradeDialogProps> = ({ open, onClose }) => {
    const handleUpgrade = () => {
        window.parent.postMessage(
          { action: "redirect", url: "https://app.qrcompose.com/register/starter/monthly" },
          "*"
        );
    };
      

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><b>Download complete!</b></DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Upgrade to access advanced QR analytics, custom branding, multiple users, and powerful features to maximize your QR codes.
        </Typography>
        
        <List>
          <ListItem>
            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
            <ListItemText primary="Advanced QR Code Analytics" secondary="Track scans, locations, and user interactions with detailed analytics." />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
            <ListItemText primary="Link Trees & Custom Forms" secondary="Create dynamic landing pages and forms linked to your QR codes." />
          </ListItem>
          <ListItem>
            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
            <ListItemText primary="Multi-User Access & Team Collaboration" secondary="Share QR management with your team and control user access." />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: 'none' }} color="inherit">Maybe Later</Button>
        <Button onClick={handleUpgrade} startIcon={<RocketLaunchIcon />} sx={{ textTransform: 'none', backgroundColor: "#000", color: "#fff" }} variant="contained">Upgrade</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadUpgradeDialog;
